import { render, staticRenderFns } from "./products-quick-search.vue?vue&type=template&id=07396b0a&"
import script from "./products-quick-search.vue.ts?vue&type=script&lang=ts&"
export * from "./products-quick-search.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports